import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import styles from '../../constants/stylesDefault';
import SignInForm from '../../components/SignInForm/SignInForm';
import { PASSWORD_FORGET } from '../../constants/routes';
import SmallPaper from '../../components/Layout/SmallPaper';

const PasswordForgetLink = () =>
    <p>
        <Link to={PASSWORD_FORGET}>Mot de passe oublié ?</Link>
    </p>;

const SignInPage = ({ history }) =>
    <SmallPaper>
        <div style={styles.center}>
            <img alt="Koboo" src="/logo.svg" style={styles.logo}/>
            <SignInForm history={history}/>
            <PasswordForgetLink/>
        </div>
    </SmallPaper>;

export default withRouter(SignInPage);



// WEBPACK FOOTER //
// ./src/containers/SignInPage/SignInPage.jsx